import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail } from 'lucide-react';
import { navigationLinks, services, locations } from '../mockData';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white" data-testid="footer">
      <div className="container mx-auto px-4 md:px-6 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Logo and Description */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img
                src="/assets/logo.webp"
                alt="GWM — Green Web Marketing"
                className="h-12 w-12 object-contain rounded-lg"
              />
              <div>
                <p className="text-[10px] uppercase tracking-[0.2em] text-slate-400">Green Web Marketing</p>
                <p className="text-2xl font-black tracking-tight">GWM<span className="text-[#15803d]">.</span></p>
              </div>
            </div>
            <p className="text-slate-400 leading-relaxed mb-6">
              Australia's leading SEO agency delivering results-driven digital marketing solutions.
            </p>
            <div className="flex items-center gap-2 text-slate-400">
              <Phone size={18} />
              <a href="tel:1800006296" className="hover:text-[#15803d] transition-colors">
                1800 006 296
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              {navigationLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-slate-400 hover:text-[#15803d] transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Core Services */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Our Services</h3>
            <ul className="space-y-3">
              {services.slice(0, 7).map((service) => (
                <li key={service.path}>
                  <Link
                    to={service.path}
                    className="text-slate-400 hover:text-[#15803d] transition-colors text-sm"
                  >
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Industry SEO */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Industry SEO</h3>
            <ul className="space-y-3">
              {services.slice(7).map((service) => (
                <li key={service.path}>
                  <Link
                    to={service.path}
                    className="text-slate-400 hover:text-[#15803d] transition-colors text-sm"
                  >
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Other Locations */}
        <div className="border-t border-slate-800 pt-16">
          <h3 className="text-2xl font-semibold mb-8 text-center">Other Locations</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {locations.map((location, index) => (
              <div key={index} className="text-center bg-slate-800/50 p-8 rounded-2xl hover:bg-slate-800 transition-colors">
                <div className="flex justify-center mb-4">
                  <div className="w-14 h-14 bg-[#15803d] rounded-full flex items-center justify-center shadow-lg">
                    <MapPin size={24} />
                  </div>
                </div>
                <h4 className="text-xl font-bold mb-3 text-[#15803d]">{location.city}</h4>
                <p className="text-slate-400 text-sm mb-1">{location.address}</p>
                <p className="text-slate-400 text-sm mb-4">{location.suburb}</p>
                <div className="flex items-center justify-center gap-2 text-[#15803d]">
                  <Phone size={16} />
                  <a href={`tel:${location.phone}`} className="text-sm hover:text-[#166534] transition-colors">
                    {location.phone}
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 pt-8 mt-16 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-slate-400">
          <p>© 2025 Green Web Marketing. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="/sitemap" className="hover:text-[#15803d] transition-colors">
              Sitemap
            </Link>
            <Link to="/privacy" className="hover:text-[#15803d] transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms" className="hover:text-[#15803d] transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;